module.exports = __webpack_public_path__ + "static/media/gouge.581f85f8.png";